import React, { type PropsWithChildren } from 'react';
import { NavigationAppsNavItemWrapperNudgeAsync } from '@jira/software__onboarding-nudges/src/NavigationAppsNavItemWrapperNudgeAsync.tsx';
import { useHasOpened } from '@jira/software__onboarding-quickstart-has-opened/src/useHasOpened.tsx';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';

// When the Nav4Apps menuitem is rendered (which occurs both when the sidebar is visible AND hidden),
// AND when the quickstart tour is open
export function Nav4AppsSpotlightWrapper({
	children,
}: PropsWithChildren):
	| string
	| number
	| boolean
	| Iterable<React.ReactNode>
	| React.JSX.Element
	| null
	| undefined {
	const [{ hasOpened: shouldShowNudge }] = useHasOpened();

	return !__SERVER__ && shouldShowNudge ? (
		<Box xcss={fullWidthStyles}>
			<NavigationAppsNavItemWrapperNudgeAsync>{children}</NavigationAppsNavItemWrapperNudgeAsync>
		</Box>
	) : (
		children
	);
}

const fullWidthStyles = xcss({
	width: '100%',
});
